<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl />
      <div class="dashboard-status">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Inscrit en formation
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="purcentage"
                :size="80"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">{{ purcentage }}%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Bienvenue</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Votre motivation et votre persévérance ont payé : vous voici dans la communauté des futur(e)s ASV.
          </div>
          <div class="dashboard-section-content-space"/>
          <div class="dashboard-section-content-italic">
            APFORM et son centre de formation sont à vos côtés pour vous accompagner vers votre nouveau métier !
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="comments !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Un commentaire a été déposé sur votre espace</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{comments}}</pre>
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="ofVacationDateAsString !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Congés annuels de votre centre de rattachement</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ ofVacationDateAsString }}</pre>
          </div>
        </div>
      </div>


      <div class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Infos formation</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
                        <span class="dashboard-section-content-bold">
                            {{ textCampusRegistered }}
                        </span>
          </div>
          <div class="dashboard-section-content-space"/>
          Type de contrat : <span class="dashboard-section-content-bold"> {{ typeContrat }} </span><br>
          Date du contrat : du <span class="dashboard-section-content-bold"> {{ dateDebutContrat }} </span> au <span class="dashboard-section-content-bold"> {{ dateEndContrat }} </span><br>
          Date de la promo : du <span class="dashboard-section-content-bold"> {{ dateDebutPromo }} </span> au <span class="dashboard-section-content-bold"> {{ dateFinPromo }} </span><br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'

export default {
  name: "DashboardRegistered",
  components: {
    DashboardHeader,
  },
  props: {
    firstname: String,
    purcentage: Number,
    textCampusRegistered: String,
    typeContrat: String,
    dateDebutContrat: String,
    dateEndContrat: String,
    dateDebutPromo: String,
    dateFinPromo: String,
    comments: String,
    ofVacationDateAsString: String,
    profilePictureUrl: String,
  }
};
</script>
